export const PushNotificationType = {
  ERROR: 'Error',
  WARNING: 'Warning',
  INFO: 'Info',
  SUCCESS: 'Success',
};

export const PushNotificationSourceType = {
  LOAN: 'Loan',
  PIPELINE: 'Pipeline',
  SYSTEM: 'System',
  USER: 'User',
};

export const PushNotificationSourceTypeLabel = {
  [PushNotificationSourceType.LOAN]: 'Loan',
  [PushNotificationSourceType.PIPELINE]: 'Pipeline',
  [PushNotificationSourceType.SYSTEM]: 'System',
  [PushNotificationSourceType.USER]: 'User',
};

export const PushNotificationConnectionStatus = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
};

export const PUSH_NOTIFICATION_BADGE_MAX = 99;

export const PushNotificationSignalRMethod = {
  CONNECT: 'connectToNotificationHub',
  DISCONNECT: 'disconnectFromNotificationHub',
  NOTIFICATION_CREATED: 'NotificationCreated',
  HEARTBEAT: 'heartbeat',
};

export const PUSH_NOTIFICATION_HEARTBEAT_INTERVAL_MS = 300_000;
